<template>
    <div class="price-details-item-v2 py-1.5 px-4">
        <div
            class="text-[#2C2C4F] pr-2" 
            :class="fontEmphasized ? 'font-bold' : 'font-normal'"
        >
            {{ title }}
        </div>

        <div :class="`text-[${valueStringColor}] ${fontEmphasized ? 'font-bold' : 'font-normal'}`">
            {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        valueStringColor: {
            type: String,
            required: false,
            default: '#2C2C4F',
        },
        fontEmphasized: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style>
.price-details-item-v2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>